import { render, staticRenderFns } from "./one_off_invoice_result.vue?vue&type=template&id=61a6cf20&"
import script from "./one_off_invoice_result.vue?vue&type=script&lang=js&"
export * from "./one_off_invoice_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports